module.exports = __webpack_public_path__ + "src/assets/img/bg_vas_tarot.39769bc4.svg";